import BaseComponent from "../../../baseComponent.js";
import styles from "./legends.scss";

export default class Legend extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleClick(event) {
    if ($(event.target).hasClass(styles.legendRemoveBtn)) {
      this.props.removeCurrentLegend(this.props.legend);
    } else {
      this.props.changeCurrentLegend(event.currentTarget, this.props.legend);
    }
  }

  render() {
    let colorStyle = {
      backgroundColor: this.props.legend.parameters.legendColor
    };
    let removeIcon = null, selectedStyle = {};
    if (this.props.isSelected) {
      removeIcon = <i className={["material-icons", styles.legendRemoveBtn].join(" ")}>close</i>;
      selectedStyle["boxShadow"] = "inset 0 -2px 0 0 " + this.props.legend.parameters.legendColor;
    }
    let label = this.props.legend.parameters.legendLabel;
    if (label.length === 0) label = " ";
    return (
      <div className={styles.legend} id={"legend-" + this.props.legend.id} onClick={this.handleClick}>
        <div className={styles.legendColor} style={colorStyle}></div>
        <div className={styles.legendLabel} style={selectedStyle}>{label}</div>
        {removeIcon}
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legends/legend.jsx